// BSV CHANGES 
import { jfwReducer } from '@app/screens/module-specific-utilities/pages/dcr-jfw/redux';

type RootState = {
  jfw: ReturnType<typeof jfwReducer>;
};

// ✅ Base selector to get the whole slice
export const jfwStateSelector = (state: RootState) => state.jfw;

// ✅ Direct selectors for convenience
export const getJfwLoading = (state: RootState) =>
  jfwStateSelector(state).loading;

export const getJfwData = (state: RootState) =>
  jfwStateSelector(state).data;
